import * as React from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import CssBaseline from '@material-ui/core/CssBaseline'
import { MuiThemeProvider } from '@material-ui/core/styles'
import ReactDOM from 'react-dom'

import App from './containers/App'
import configureStore from './store'

import * as serviceWorker from './serviceWorker'
import theme from './theme'

import { GlobalStyle } from './injectGlobal'
import config from './config'

const { store, persistor } = configureStore()

const root = document.getElementById('root')

console.log({ versino: config.gitrev })

if (root) {
  ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div>
          <CssBaseline />
          <GlobalStyle />
          <MuiThemeProvider theme={theme}>
            <App />
          </MuiThemeProvider>
        </div>
      </PersistGate>
    </Provider>,
    root,
  )
}

serviceWorker.unregister()
